import { useSearchParams } from "react-router-dom";
import PlatformIntelligence from "./PlatformIntelligence";

// iter451 — Pulse now hosts what used to be the standalone "Intelligence" page as a Themes tab,
// so portfolio/platform insights live in one place. `pulse` is the console's own Pulse element.
export default function PulseTabs({ pulse }) {
  const [sp, setSp] = useSearchParams();
  const tab = sp.get("tab") === "themes" ? "themes" : "pulse";
  const go = (k) => setSp(k === "pulse" ? {} : { tab: k });
  return (
    <div className="space-y-5">
      <div className="inline-flex rounded-full bg-sand-100 border border-sand-200 p-1" data-testid="pulse-tabs">
        {[["pulse", "Pulse"], ["themes", "Themes"]].map(([k, l]) => (
          <button key={k} type="button" data-testid={`pulse-tab-${k}`} onClick={() => go(k)}
            className={`rounded-full px-4 py-1.5 text-sm font-semibold transition-colors ${tab === k ? "bg-ink text-white shadow-sm" : "text-ink/60 hover:text-ink"}`}>{l}</button>
        ))}
      </div>
      {tab === "themes" ? <PlatformIntelligence /> : pulse}
    </div>
  );
}
